﻿import $ from "jquery";
import { ChangeSedcardDto, SedcardType } from "./changeSedcardDto";
import { EditableItemList, MovingDirection } from "./editableItemList";


export class EditableSponsorItemList extends EditableItemList<ChangeSedcardDto> {
    private readonly emptyGuidString = "00000000-0000-0000-0000-000000000000";

    init(divElementId: string, buttonId: string) {
        this.itemList = $(`#${divElementId}`).data("initial");

        super.init(divElementId, buttonId); //addSedcardItemButton
    }

    protected drawItem(item: ChangeSedcardDto, itemId: number) {
        // == is placed here on purpose for comparison of string.empty
        const SpeakerImageUrl = item.SpeakerImage === this.emptyGuidString ? "" : `/fileasset/${item.SpeakerImage}`;
        const LogoUrl = item.Logo === this.emptyGuidString ? "" : `/fileasset/${item.Logo}`;
        const MeetLogoUrl = item.MeetLogoId === this.emptyGuidString ? "" : `/fileasset/${item.MeetLogoId}`;
        const MeetJoinImagePreviewUrl = item.MeetJoinImageId == this.emptyGuidString ? "" : `/fileasset/${item.MeetJoinImageId}`;

        fetch('/partialview/sponsor')
            .then(response => response.text())
            .then(htmlElement => {

                var re = /itemId/gi;
                var itemElement = htmlElement.replace(re, ("" + itemId));
                var itemElement = itemElement.replace("{{Name}}", item.Name == null ? "" : item.Name);
                var itemElement = itemElement.replace("{{Title}}", item.Title == null ? "" : item.Title);
                var itemElement = itemElement.replace("{{Company}}", item.Company == null ? "" : item.Company);
                var itemElement = itemElement.replace("{{Telephone}}", item.Telephone == null ? "" : item.Telephone);
                var itemElement = itemElement.replace("{{Email}}", item.Email == null ? "" : item.Email);
                var itemElement = itemElement.replace("{{Website}}", item.Website == null ? "" : item.Website);
                var itemElement = itemElement.replace("{{Address}}", item.Address == null ? "" : item.Address);
                var itemElement = itemElement.replace("{{LinkedInProfile}}", item.LinkedInProfile == null ? "" : item.LinkedInProfile);
                var itemElement = itemElement.replace("{{Description}}", item.Description == null ? "" : item.Description);
                var itemElement = itemElement.replace("{{Background}}", item.Background);
                var itemElement = itemElement.replace("{{Fontcolor}}", item.FontColor);
                var itemElement = itemElement.replace("{{MeetName}}", item.MeetName == null ? "" : item.MeetName);
                var itemElement = itemElement.replace("{{WelcomeMessage}}", item.MeetWelcomeMessage == null ? "" : item.MeetWelcomeMessage);
                var itemElement = itemElement.replace("{{WelcomeMessageModerator}}", item.MeetWelcomeMessageModerator == null ? "" : item.MeetWelcomeMessageModerator);
                var itemElement = itemElement.replace("{{MeetLogoutUrl}}", item.MeetLogoutUrl == null ? "" : item.MeetLogoutUrl);
                var itemElement = itemElement.replace("{{MeetBackgroundColor}}", item.MeetBackgroundColor);
                var itemElement = itemElement.replace("{{layoutLogoPreview}}", LogoUrl);
                var itemElement = itemElement.replace("{{layoutSpeakerImagePreview}}", SpeakerImageUrl);
                var itemElement = itemElement.replace("{{sedcardMeetLogoPreview}}", MeetLogoUrl);
                var itemElement = itemElement.replace("{{sedcardMeetJoinImage}}", MeetJoinImagePreviewUrl);
                var itemElement = itemElement.replace("{{PlayerHeader}}", item.PlayerHeader == null ? "" : item.PlayerHeader);
                var itemElement = itemElement.replace("{{PlayerContent}}", item.PlayerContent == null ? "" : item.PlayerContent);
                var itemElement = itemElement.replace('checked="checked"', "");
                if (item.CardType == SedcardType.Speaker) {
                    var itemElement = itemElement.replace("{{checkSpeakerButton}}", "checked");
                    var itemElement = itemElement.replace("{{checkSponsorButton}}", "");
                }
                else if (item.CardType == SedcardType.Sponsor) {
                    var itemElement = itemElement.replace("{{checkSpeakerButton}}", "");
                    var itemElement = itemElement.replace("{{checkSponsorButton}}", "checked");
                }

                $(`#${this.divElementId}`).append(itemElement);

                $(`#sedcardName-${itemId}`).change(() => {
                    this.itemList[itemId].Name = String($(`#sedcardName-${itemId}`).val());
                });

                $(`#sedcardTitle-${itemId}`).change(() => {
                    this.itemList[itemId].Title = String($(`#sedcardTitle-${itemId}`).val());
                });

                $(`#sedcardCompany-${itemId}`).change(() => {
                    this.itemList[itemId].Company = String($(`#sedcardCompany-${itemId}`).val());
                });

                $(`#sedcardTelephone-${itemId}`).change(() => {
                    this.itemList[itemId].Telephone = String($(`#sedcardTelephone-${itemId}`).val());
                });

                $(`#sedcardEmail-${itemId}`).change(() => {
                    this.itemList[itemId].Email = String($(`#sedcardEmail-${itemId}`).val());
                });

                $(`#sedcardWebsite-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardWebsite-${itemId}`).val());
                });

                $(`#sedcardLinkedInProfile-${itemId}`).change(() => {
                    this.itemList[itemId].LinkedInProfile = String($(`#sedcardLinkedInProfile-${itemId}`).val());
                });

                $(`#sedcardAddress-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardAddress-${itemId}`).val());
                });

                $(`#sedcardDescription-${itemId}`).change(() => {
                    this.itemList[itemId].Description = String($(`#sedcardDescription-${itemId}`).val());
                });

                $(`#sedcardBackground-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardBackground-${itemId}`).val());
                });

                $(`#sedcardFrontColor-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardFrontColor-${itemId}`).val());
                });

                $(`#setcardMeetName-${itemId}`).change(() => {
                    this.itemList[itemId].MeetName = String($(`#setcardMeetName-${itemId}`).val());
                });

                $(`#sedcardMeetWelcomeMessage-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardMeetWelcomeMessage-${itemId}`).val());
                });

                $(`#sedcardMeetWelcomeMessageModerator-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardMeetWelcomeMessageModerator-${itemId}`).val());
                });

                $(`#sedcardMeetLogoutUrl-${itemId}`).change(() => {
                    this.itemList[itemId].Website = String($(`#sedcardMeetLogoutUrl-${itemId}`).val());
                });

                $(`#SedcardPlayerHeader-${itemId}`).change(() => {
                    this.itemList[itemId].PlayerHeader = String($(`#SedcardPlayerHeader-${itemId}`).val());
                });

                $(`#PlayerContent-${itemId}`).change(() => {
                    this.itemList[itemId].PlayerContent = String($(`#PlayerContent-${itemId}`).val());
                });



                $(`#RadioButtonSedcardSponsor-${itemId}`).change(() => {
                    console.log("sponsor active");
                    this.itemList[itemId].CardType = SedcardType.Sponsor;
                });

                $(`#RadioButtonSedcardSpeaker-${itemId}`).change(() => {
                    console.log("speaker active");
                    this.itemList[itemId].CardType = SedcardType.Speaker;
                });



                $(`#sponsorLogoInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#sponsorLogoInput-${itemId}`)[0], `sponsorLogoPreview-${itemId}`, `sponsorLogoLabel-${itemId}`);
                });

                $(`#sponsorSpeakerImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#sponsorSpeakerImageInput-${itemId}`)[0], `sponsorSpeakerImagePreview-${itemId}`, `sponsorSpeakerImageLabel-${itemId}`);
                });

                $(`#sponsorMeetLogoInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#sponsorMeetLogoInput-${itemId}`)[0], `sponsorMeetLogoPreview-${itemId}`, `sponsorMeetLogoLabel-${itemId}`);
                });

                $(`#sponsorMeetJoinImageInput-${itemId}`).change(() => {
                    console.log("IMAGE CHANGED");
                    this.readUrl($(`#sponsorMeetJoinImageInput-${itemId}`)[0], `sponsorMeetJoinImagePreview-${itemId}`, `sponsorMeetJoinImageLabel-${itemId}`);
                });


                $(`#sedcardFieldMoveUp-${itemId}`).click(() => {
                    this.moveItem(MovingDirection.Up, itemId);
                    this.redrawItems();
                });

                $(`#sedcardFieldMoveDown-${itemId}`).click(() => {
                    this.moveItem(MovingDirection.Down, itemId);
                    this.redrawItems();
                });

                $(`#sedcardFieldRemove-${itemId}`).click(() => {
                    this.itemList.splice(itemId, 1);
                    this.redrawItems();
                });
            });
    }

    protected addNewItem() {
        const defaultSedcardDto: ChangeSedcardDto = {
            Name: "Name des Teilnehmers",
            CardType: SedcardType.Speaker,
            Title: "",
            Company: "",
            Logo: this.emptyGuidString,
            LogoChanged: null,
            SpeakerImage: this.emptyGuidString,
            SpeakerImageChanged: null,
            Telephone: "",
            LinkedInProfile: "",
            Email: "",
            Website: "",
            Address: "",
            Background: "#D6D6D6",
            Description: "",
            FontColor: "#000000",
            MeetLogoId: this.emptyGuidString,
            MeetLogoChanged: null,
            MeetJoinImageId: this.emptyGuidString,
            MeetJoinImageChanged: null,
            MeetPresentationId: this.emptyGuidString,
            MeetPresentationChanged: null,
            MeetName: "Meetingname",
            MeetBackgroundColor: "#06172A",
            MeetLogoutUrl: "https://streamdiver.com",
            MeetWelcomeMessage: "Wilkommen zu Streamdiver Meet!<br>Hier finden Sie die Bedienungsanleitung: https://sdv.to/mud <br>Here you can find the user manual: https://sdv.to/mue",
            MeetWelcomeMessageModerator: "Wilkommen Moderator",
            PlayerHeader: "",
            PlayerContent: ""
        };
        this.itemList.push(defaultSedcardDto);
    }

    // See https://stackoverflow.com/questions/4459379/preview-an-image-before-it-is-uploaded
    protected readUrl(input, previewId, labelId) {
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (e !== null && e.target !== null) {
                    $("#" + previewId).prop("src", e.target.result);
                }
            }

            // Set input label
            reader.readAsDataURL(input.files[0]); // convert to base64 string
            $("#" + labelId).val(input.files[0].name);
        }
    }

    // Returns a date as string in the format yyyy-MM-ddThh:mm
    protected getDateTimeString(date: Date) {
        // For some strange reason, the parameter date can not be used directly ...
        // Therefore, another variable must be initialized
        const sameDate = new Date(date);
        return (`${sameDate.getFullYear().toString()}-${(`0${sameDate.getMonth() + 1}`).slice(-2)}-${(`0${sameDate.getDate()}`).slice(-2)}T${(`0${sameDate.getHours()}`).slice(-2)}:${(`0${sameDate.getMinutes()}`).slice(-2)}`)
    }
}